<template>
  <div class="content" v-if="route.name == 'Beranda'">
    <Beranda/>
  </div>
  <div class="content" v-if="route.name == 'Login'">
    <Login/>
  </div>
  <div class="content" v-if="route.name == 'KontakKami'">
    <KontakKami/>
  </div>
  <div class="content" v-if="route.name == 'DaftarSocial'">
    <DaftarSocial/>
  </div>
  <div class="content" v-if="route.name == 'DaftarEnvironmental'">
    <DaftarEnvironmental/>
  </div>
  <div class="content" v-if="route.name == 'MasukanSaran'">
    <MasukanSaran/>
  </div>
  <div class="content" v-if="route.name == 'DaftarProgramBudgeting'">
    <DaftarProgramBudgeting/>
  </div>
  <div class="content" v-if="route.name == 'DaftarFinance'">
    <DaftarFinance/>
  </div>
  <div class="content" v-if="route.name == 'DaftarPDOIOS'">
    <DaftarPDOIOS/>
  </div>
  <div class="content" v-if="route.name == 'DaftarQuickStatus'">
    <DaftarQuickStatus/>
  </div>
  <div class="content" v-if="route.name == 'DaftarAduan'">
    <DaftarAduan/>
  </div>
  <div class="content" v-if="route.name == 'DaftarMonev'">
    <DaftarMonev/>
  </div>
  <div class="content" v-if="route.name == 'Aduan'">
    <Aduan/>
  </div>
  <div class="content" v-if="route.name == 'CariAduan'">
    <CariAduan/>
  </div>
  <div class="content" v-if="route.name == 'DaftarKegiatan'">
    <DaftarKegiatan/>
  </div>
  <div class="content" v-if="route.name == 'DaftarBerita'">
    <DaftarBerita/>
  </div>
  <div class="content" v-if="route.name == 'DaftarAlbum'">
    <DaftarAlbum/>
  </div>
  <div class="content" v-if="route.name == 'DaftarGaleri'">
    <DaftarGaleri/>
  </div>
  <div class="content" v-if="route.name == 'DaftarAlbumDokumen'">
    <DaftarAlbumDokumen/>
  </div>
  <div class="content" v-if="route.name == 'DaftarGaleriDokumen'">
    <DaftarGaleriDokumen/>
  </div>
  <div class="content" v-if="route.name == 'DaftarStatus'">
    <DaftarStatus/>
  </div>
  <div class="content" v-if="route.name == 'DaftarGESIAP'">
    <DaftarGESIAP/>
  </div>
  <div class="content" v-if="route.name == 'Dashboard'">
    <Dashboard/>
  </div>
  <div class="content" v-if="route.name == 'Slider'">
    <Slider/>
  </div>
  <div class="content" v-if="route.name == 'ProsesSlider'">
    <ProsesSlider/>
  </div>
  <div class="content" v-if="route.name == 'Kategori'">
    <Kategori/>
  </div>
  <div class="content" v-if="route.name == 'ProsesKategori'">
    <ProsesKategori/>
  </div>
  <div class="content" v-if="route.name == 'SubKategori'">
    <SubKategori/>
  </div>
  <div class="content" v-if="route.name == 'ProsesSubKategori'">
    <ProsesSubKategori/>
  </div>
  <div class="content" v-if="route.name == 'UnitKategori'">
    <UnitKategori/>
  </div>
  <div class="content" v-if="route.name == 'ProsesUnitKategori'">
    <ProsesUnitKategori/>
  </div>
  <div class="content" v-if="route.name == 'InfoBeranda'">
    <InfoBeranda/>
  </div>
  <div class="content" v-if="route.name == 'ProsesInfoBeranda'">
    <ProsesInfoBeranda/>
  </div>
  <div class="content" v-if="route.name == 'Konten'">
    <Konten/>
  </div>
  <div class="content" v-if="route.name == 'ProsesKonten'">
    <ProsesKonten/>
  </div>
  <div class="content" v-if="route.name == 'User'">
    <User/>
  </div>
  <div class="content" v-if="route.name == 'ProsesUser'">
    <ProsesUser/>
  </div>
  <div class="content" v-if="route.name == 'Monev'">
    <Monev/>
  </div>
  <div class="content" v-if="route.name == 'ProsesMonev'">
    <ProsesMonev/>
  </div>
  <div class="content" v-if="route.name == 'ProsesPDOMonev'">
    <ProsesPDOMonev/>
  </div>
  <div class="content" v-if="route.name == 'IPP'">
    <IPP/>
  </div>
  <div class="content" v-if="route.name == 'GAP'">
    <GAP/>
  </div>
  <div class="content" v-if="route.name == 'PDOIOS'">
    <PDOIOS/>
  </div>
  <div class="content" v-if="route.name == 'ProsesPDOIOS'">
    <ProsesPDOIOS/>
  </div>
  <div class="content" v-if="route.name == 'Gesiap'">
    <Gesiap/>
  </div>
  <div class="content" v-if="route.name == 'ProsesGesiap'">
    <ProsesGesiap/>
  </div>
  <div class="content" v-if="route.name == 'DetailProsesGesiap'">
    <DetailProsesGesiap/>
  </div>
  <div class="content" v-if="route.name == 'CEMP'">
    <CEMP/>
  </div>
  <div class="content" v-if="route.name == 'RKLRPL'">
    <RKLRPL/>
  </div>
  <div class="content" v-if="route.name == 'Sampel'">
    <Sampel/>
  </div>
  <div class="content" v-if="route.name == 'Regulasi'">
    <Regulasi/>
  </div>
  <div class="content" v-if="route.name == 'ProsesRegulasi'">
    <ProsesRegulasi/>
  </div>
  <div class="content" v-if="route.name == 'DaftarRegulasi'">
    <DaftarRegulasi/>
  </div>
  <div class="content" v-if="route.name == 'KategoriData'">
    <KategoriData/>
  </div>
  <div class="content" v-if="route.name == 'ProsesKategoriData'">
    <ProsesKategoriData/>
  </div>
  <div class="content" v-if="route.name == 'AduanMasyarakat'">
    <AduanMasyarakat/>
  </div>
  <div class="content" v-if="route.name == 'ProsesAduanMasyarakat'">
    <ProsesAduanMasyarakat/>
  </div>
  <div class="content" v-if="route.name == 'TindaklanjutAduanMasyarakat'">
    <TindaklanjutAduanMasyarakat/>
  </div>
  <div class="content" v-if="route.name == 'ProsesKurvaS'">
    <ProsesKurvaS/>
  </div>
  <div class="content" v-if="route.name == 'KendalaTindakLanjut'">
    <KendalaTindakLanjut/>
  </div>
  <div class="content" v-if="route.name == 'LayerPeta'">
    <LayerPeta/>
  </div>
  <div class="content" v-if="route.name == 'Berita'">
    <Berita/>
  </div>
  <div class="content" v-if="route.name == 'ProsesBerita'">
    <ProsesBerita/>
  </div>
  <div class="content" v-if="route.name == 'Galeri'">
    <Galeri/>
  </div>
  <div class="content" v-if="route.name == 'ProsesGaleri'">
    <ProsesGaleri/>
  </div>
  <div class="content" v-if="route.name == 'DetailGaleri'">
    <DetailGaleri/>
  </div>
  <div class="content" v-if="route.name == 'Dokumen'">
    <Dokumen/>
  </div>
  <div class="content" v-if="route.name == 'ProsesDokumen'">
    <ProsesDokumen/>
  </div>
  <div class="content" v-if="route.name == 'DetailDokumen'">
    <DetailDokumen/>
  </div>
  <div class="content" v-if="route.name == 'GIS'">
    <GIS/>
  </div>
  <div class="content" v-if="route.name == 'DaftarKonten'">
    <DaftarKonten/>
  </div>
  <div class="content" v-if="route.name == 'ImportExcel'">
    <ImportExcel/>
  </div>
  <div class="content" v-if="route.name == 'FAQ'">
    <FAQ/>
  </div>
  <div class="content" v-if="route.name == 'DataDokumen'">
    <DataDokumen/>
  </div>
  <div class="content" v-if="route.name == 'Environment'">
    <Environment/>
  </div>
  <div class="content" v-if="route.name == 'ProsesEnvironment'">
    <ProsesEnvironment/>
  </div>
  <div class="content" v-if="route.name == 'Social'">
    <Social/>
  </div>
  <div class="content" v-if="route.name == 'ProsesSocial'">
    <ProsesSocial/>
  </div>
  <div class="content" v-if="route.name == 'Finance'">
    <Finance />
  </div>
  <div class="content" v-if="route.name == 'ProsesDIPA'">
    <ProsesDIPA />
  </div>
  <div class="content" v-if="route.name == 'ProsesSPM'">
    <ProsesSPM />
  </div>
</template>

<script>
import Beranda from './components/views/Publik/Beranda.vue';
import Login from './components/views/Publik/Login.vue';
import KontakKami from './components/views/Publik/KontakKami.vue';
import DaftarSocial from './components/views/Publik/DaftarSocial.vue';
import DaftarEnvironmental from './components/views/Publik/DaftarEnvironmental.vue';
import MasukanSaran from './components/views/Publik/MasukanSaran.vue';
import DaftarProgramBudgeting from './components/views/Publik/DaftarProgramBudgeting.vue';
import DaftarFinance from './components/views/Publik/DaftarFinance.vue';
import DaftarPDOIOS from './components/views/Publik/DaftarPDOIOS.vue';
import DaftarQuickStatus from './components/views/Publik/DaftarQuickStatus.vue';
import DaftarAduan from './components/views/Publik/DaftarAduan.vue';
import DaftarMonev from './components/views/Publik/DaftarMonev.vue';
import Aduan from './components/views/Publik/Aduan.vue';
import FAQ from './components/views/Publik/FAQ.vue';
import CariAduan from './components/views/Publik/CariAduan.vue';
import Dashboard from './components/views/Dashboard/Dashboard.vue';
import Slider from './components/views/Backoffice/Slider/Slider.vue';
import ProsesSlider from './components/views/Backoffice/Slider/ProsesSlider.vue';
import Kategori from './components/views/Backoffice/Kategori/Kategori.vue';
import ProsesKategori from './components/views/Backoffice/Kategori/ProsesKategori.vue';
import SubKategori from './components/views/Backoffice/SubKategori/SubKategori.vue';
import ProsesSubKategori from './components/views/Backoffice/SubKategori/ProsesSubKategori.vue';
import UnitKategori from './components/views/Backoffice/UnitKategori/UnitKategori.vue';
import ProsesUnitKategori from './components/views/Backoffice/UnitKategori/ProsesUnitKategori.vue';
import InfoBeranda from './components/views/Backoffice/InfoBeranda/InfoBeranda.vue';
import ProsesInfoBeranda from './components/views/Backoffice/InfoBeranda/ProsesInfoBeranda.vue';
import Konten from './components/views/Backoffice/Konten/Konten.vue';
import ProsesKonten from './components/views/Backoffice/Konten/ProsesKonten.vue';
import User from './components/views/Backoffice/User/User.vue';
import ProsesUser from './components/views/Backoffice/User/ProsesUser.vue';
import Monev from './components/views/Backoffice/Monev/Monev.vue';
import ProsesMonev from './components/views/Backoffice/Monev/ProsesMonev.vue';
import ProsesPDOMonev from './components/views/Backoffice/Monev/ProsesPDOMonev.vue';
import IPP from './components/views/Backoffice/IPP/IPP.vue';
import ImportExcel from './components/views/ImportExcel/ImportExcel.vue';
import GAP from './components/views/Backoffice/GAP/GAP.vue';
import PDOIOS from './components/views/Backoffice/PDOIOS/PDOIOS.vue';
import ProsesPDOIOS from './components/views/Backoffice/PDOIOS/ProsesPDOIOS.vue';
import Gesiap from './components/views/Backoffice/Gesiap/Gesiap.vue';
import ProsesGesiap from './components/views/Backoffice/Gesiap/ProsesGesiap.vue';
import DetailProsesGesiap from './components/views/Backoffice/Gesiap/DetailProsesGesiap.vue';
import CEMP from './components/views/Backoffice/CEMP/CEMP.vue';
import RKLRPL from './components/views/Backoffice/RKLRPL/RKLRPL.vue';
import Sampel from './components/views/Backoffice/Sampel/Sampel.vue';
import Regulasi from './components/views/Backoffice/Regulasi/Regulasi.vue';
import ProsesRegulasi from './components/views/Backoffice/Regulasi/ProsesRegulasi.vue';
import DaftarRegulasi from './components/views/Publik/DaftarRegulasi.vue';
import AduanMasyarakat from './components/views/Backoffice/AduanMasyarakat/AduanMasyarakat.vue';
import ProsesAduanMasyarakat from './components/views/Backoffice/AduanMasyarakat/ProsesAduanMasyarakat.vue';
import TindaklanjutAduanMasyarakat from './components/views/Backoffice/AduanMasyarakat/TindaklanjutAduanMasyarakat.vue';
import KategoriData from './components/views/Backoffice/KategoriData/KategoriData.vue';
import ProsesKategoriData from './components/views/Backoffice/KategoriData/ProsesKategoriData.vue';
import LayerPeta from './components/views/Backoffice/LayerPeta/LayerPeta.vue';
import GIS from './components/views/Publik/GIS.vue';
import DaftarKonten from './components/views/Publik/DaftarKonten.vue';
import DaftarKegiatan from './components/views/Publik/DaftarKegiatan.vue';
import DaftarBerita from './components/views/Publik/DaftarBerita.vue';
import Berita from './components/views/Backoffice/Berita/Berita.vue';
import ProsesBerita from './components/views/Backoffice/Berita/ProsesBerita.vue';
import DaftarAlbum from './components/views/Publik/DaftarAlbum.vue';
import DaftarGaleri from './components/views/Publik/DaftarGaleri.vue';
import Galeri from './components/views/Backoffice/Galeri/Galeri.vue';
import ProsesGaleri from './components/views/Backoffice/Galeri/ProsesGaleri.vue';
import DetailGaleri from './components/views/Backoffice/Galeri/DetailGaleri.vue';
import Dokumen from './components/views/Backoffice/Dokumen/Dokumen.vue';
import ProsesDokumen from './components/views/Backoffice/Dokumen/ProsesDokumen.vue';
import DetailDokumen from './components/views/Backoffice/Dokumen/DetailDokumen.vue';
import DaftarAlbumDokumen from './components/views/Publik/DaftarAlbumDokumen.vue';
import DaftarGaleriDokumen from './components/views/Publik/DaftarGaleriDokumen.vue';
import DaftarStatus from './components/views/Publik/DaftarStatus.vue';
import DaftarGESIAP from './components/views/Publik/DaftarGESIAP.vue';
import DataDokumen from './components/views/Backoffice/NewDokumen/Dokumen.vue';
import ProsesKurvaS from './components/views/Backoffice/Monev/ProsesKurvaS.vue';
import KendalaTindakLanjut from './components/views/Backoffice/Monev/KendalaTindakLanjut.vue';
import Environment from './components/views/Backoffice/Environment/Environment.vue';
import ProsesEnvironment from './components/views/Backoffice/Environment/ProsesEnvironment.vue';
import Social from './components/views/Backoffice/Social/Social.vue';
import ProsesSocial from './components/views/Backoffice/Social/ProsesSocial.vue';
import Finance from './components/views/Backoffice/Finance/Finance.vue';
import ProsesDIPA from './components/views/Backoffice/Finance/ProsesDIPA.vue';
import ProsesSPM from './components/views/Backoffice/Finance/ProsesSPM.vue';


import { useRoute } from 'vue-router';
import { watch } from 'vue';

export default {
  name: 'App',
  components: {
    Beranda,Login,KontakKami,DaftarSocial,DaftarEnvironmental,MasukanSaran,Dashboard,GIS,DaftarKonten,DaftarProgramBudgeting
    ,DaftarFinance,DaftarMonev,DaftarPDOIOS,DaftarQuickStatus,Aduan,DaftarAduan,CariAduan
    ,Slider,ProsesSlider,InfoBeranda,ProsesInfoBeranda,Konten,ProsesKonten
    ,User,ProsesUser,KategoriData,ProsesKategoriData,Monev,ProsesMonev,ProsesPDOMonev,CEMP,Sampel
    ,Regulasi,ProsesRegulasi,DaftarRegulasi,Kategori,ProsesKategori
    ,SubKategori,ProsesSubKategori,UnitKategori,ProsesUnitKategori
    ,LayerPeta,RKLRPL,IPP,GAP,PDOIOS,ImportExcel
    ,DaftarKegiatan,Berita,ProsesBerita,DaftarBerita,Galeri,ProsesGaleri,DetailGaleri
    ,DaftarAlbum,DaftarGaleri,Dokumen,ProsesDokumen,DetailDokumen
    ,DaftarAlbumDokumen,DaftarGaleriDokumen,AduanMasyarakat,ProsesAduanMasyarakat,TindaklanjutAduanMasyarakat
    ,FAQ,DaftarGESIAP,DataDokumen,ProsesPDOIOS,Gesiap,ProsesGesiap,DetailProsesGesiap,ProsesKurvaS,KendalaTindakLanjut,Social,ProsesSocial
    ,Environment,ProsesEnvironment,DaftarStatus, Finance, ProsesDIPA, ProsesSPM
  },
  mounted() {
    document.title = "PPMS FMNJP";
  },
  setup() {
    const route = useRoute()
    watch(() => route.name, () => {
    });

    return { route };
  }
}
</script>

<style></style>
